<template>
  <div>
    <div class="md-table-cell-container">
      <md-button
        class="md-just-icon md-warning md-simple table-action"
        @click.native="triggerViewAttendances"
      >
        <md-tooltip md-direction="top">View attendances</md-tooltip>
        <md-icon>visibility</md-icon>
      </md-button>
    </div>
  </div>
</template>

<script>
import { service_paths } from "@/constants/Services";
import { getTimeString, isSameDate } from "@/helpers/datetime-helper";
import { mapGetters } from "vuex";
import moment from "moment-timezone";

export default {
  props: ["item"],
  inject: ["viewAttendances", "reportParams"],
  data() {
    return {
      path: `${service_paths.attendances}/user`
    };
  },
  computed: {
    studentId() {
      return this.reportParams.student_id;
    },
    ...mapGetters("user", {
      userTz: "timezone"
    })
  },
  methods: {
    async triggerViewAttendances() {
      try {
        const { id: classId, class_name: className } = this.item;
        const attendances = await this.fetchAttendancesOfClass(classId);
        this.viewAttendances(className, attendances);
      } catch (error) {}
    },
    fetchAttendancesOfClass(classId) {
      return this.$axios
        .get(`${this.path}/${this.studentId}/class/${classId}`, {
          order_by: "end DESC"
        })
        .then(({ data }) => this.formatAttendances(data));
    },
    formatAttendances(orgAttendances) {
      return orgAttendances.map(orgAttd => ({
        id: orgAttd.calendar_id,
        status: orgAttd.status,
        comment: orgAttd.description,
        dateTime: this.getUserRangeTime(
          orgAttd.calendar?.start,
          orgAttd.calendar?.end
        )
      }));
    },
    getUserRangeTime(start, end) {
      const userTz = this.userTz || moment.tz.guess();
      const startDate = getTimeString(start, userTz, "DD/MM/yyyy");
      const endDate = getTimeString(end, userTz, "DD/MM/yyyy");
      const startTime = getTimeString(start, userTz, "hh:mm A");
      const endTime = getTimeString(end, userTz, "hh:mm A");

      if (isSameDate(start, end)) {
        return `${startDate}, ${startTime} - ${endTime}`;
      }

      return `${startDate}, ${startTime} - ${endDate}, ${endTime}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.table-action {
  padding: 0 5px;
  margin: 0 2px;
}
</style>
